import React, { useState, useEffect , useCallback} from 'react';
import StepsButton from "components/sidebar/StepsButton.js";
import StepGroupEditor from "components/sidebar/StepGroupEditor.js";
import {
    SOUND_RATED,
    PRESET_RATED} from 'decentralized/xanadu/LinkTypes.js';
import FavoriteButton from "components/FavoriteButton.js";
import Documented from "components/help/Documented.js";
import {BROWSE_SOUNDS} from 'constants/contextual-help.js';
import ReactBootstrapSlider from 'react-bootstrap-slider';
import ChokesAndMatches from './ChokesAndMatches.js';
import { connect } from "react-redux";
import {
    updateStepParameter,
} from 'operations/actions.js';

import PulseLoader from 'react-spinners/PulseLoader'
import ConditionedComponent from 'components/ConditionedComponent.js';
import {SAMPLER} from 'constants/instrument-types.js';
import {
    setParametersToRecord,
} from 'actions/index.js';
import Colors from 'components/Colors.js';
const colors = new Colors();

class TrackQuickView extends React.Component {
    constructor(props) {
        super(props);

        let track = props.sequencerEngine.tracks[props.selectedTrack];
        if (track) {
            let trackData = track.trackData;
            this.state = {
                selectedParameter: trackData.durationParameter,
                value: trackData.durationParameter.value,
            }
        } else {
            this.state = {};
        }

        this.state.loading = false;
    }

    onMouseUp() {
        this.props.setParametersToRecord([]);
    }

    getTrackData(props) {
        if (props.sequencerEngine.tracks === undefined) {
            return undefined;
        }
        let track = props.sequencerEngine.tracks[props.selectedTrack];
        if (track === undefined) {
            return undefined;
        }
        return track.trackData;
    }

    get track() {
        return this.props.sequencerEngine.tracks[this.props.selectedTrack];
    }

    getThumbnail() {
        let thumbnail = undefined;
        let style = {};
        if (this.track.sample) {
            thumbnail = this.track.sample.getThumbnail();

            if (thumbnail !== undefined && thumbnail !== '') {
                return (
                    <img className="mini-thumbnail" src={thumbnail}/>
                );
            }
            
            style['backgroundColor'] = 
                colors.getColorForHash(this.track.sample.getId());
        } else {
            style['backgroundColor'] = colors.getColorForHash(this.track.presetName || this.track.getName());
        }

        return (
            <div className="mini-thumbnail" style={style}></div>
        );
    }

    shouldComponentUpdate(nextProps) {
        if (this.getTrackData(nextProps) !== this.getTrackData(this.props) ||
            nextProps.id !== this.props.id ) {
            let selectedParameter = this.state.selectedParameter;

            let trackData = this.getTrackData(nextProps);
            if (selectedParameter === undefined) {
                if (trackData !== undefined) {
                    selectedParameter = trackData.durationParameter;
                } 
            }

            if (trackData === undefined) {
                return true;
            }

            if (selectedParameter.name === 'Duration') {
                this.state.selectedParameter = (trackData.durationParameter);
            } else if (selectedParameter.name === 'Attack') {
                this.state.selectedParameter = (trackData.attackParameter);
            } else if (selectedParameter.name === 'Release') {
                this.state.selectedParameter = (trackData.releaseParameter);
            } else if (selectedParameter.name === 'Transpose') {
                this.state.selectedParameter = (trackData.transposeParameter);
            } else if (selectedParameter.name === 'Velocity') {
                this.state.selectedParameter = (trackData.velocityParameter);
            } else {
                this.state.selectedParameter = (trackData.durationParameter);
            }
            this.state.value = this.state.selectedParameter.value;
        }
        return true;
    }

    get gangMode() {
        return this.props.selectedSteps && this.props.selectedSteps.length > 0;
    }

    chooseParameter(parameter) {
        this.setState({
            selectedParameter: parameter,
            value: parameter.value,
        });
    }

    onUpdateParameter(value) {
        if (this.gangMode) {
            let parametersToUpdate = [];
            let steps = [];
            for (let step of this.props.selectedSteps) {
                steps.push(step);
                parametersToUpdate = [
                    ... parametersToUpdate,
                    ... step.parameters.filter(
                        x => x.name === this.state.selectedParameter.name)
                ];
            }
            let track = this.props.sequencerEngine.tracks &&
                this.props.sequencerEngine.tracks[this.props.selectedTrack];
            parametersToUpdate.forEach(
                (param, i) => 
                    this.props.sequencerEngine.operationManager.dispatch(
                        updateStepParameter(
                            track,
                            steps[i],
                            param,
                            value),
                        false,
                        true));
            track.updateSteps();
            this.setState({
                value: value
            });
        } else {
            this.state.selectedParameter.value = value;
            this.setState({
                value: value
            });
            this.props.setParametersToRecord([this.state.selectedParameter]);
        }
    }

    async nextSample() {
        this.setState({loading: true});
        await this.track.auditionNext(true);
        this.setState({loading: false});
    }

    async previousSample() {
        this.setState({loading: true});
        await this.track.auditionPrevious();
        this.setState({loading: false});
    }

    getValue() {
        if (this.gangMode && this.props.selectedSteps[0]) {
            let step = this.props.selectedSteps[0];
            let param = step.parameters.find(x => x.name === this.state.selectedParameter.name);
            return !param || param.get() === null ? this.state.selectedParameter.value :
                param.get();
        } else {
            return this.state.selectedParameter.value;
        }
    }
        
    render() { 
        let props = this.props;
        let track = props.sequencerEngine.tracks && props.sequencerEngine.tracks[props.selectedTrack];
        let selectedParameter = this.state.selectedParameter;
        if (props.selectedTrack === undefined || track === undefined ||
            selectedParameter === undefined) {
            return (
                <div></div>
            );
        }
        let trackData = track.trackData;
        let min = getMin(selectedParameter, trackData);
        let max = getMax(selectedParameter, trackData);

        let showGangButton = this.props.selectedSteps &&
            this.props.selectedSteps.length > 0;
        
        let favoriteButton = '';
        if (track &&
            track.preset &&
            track.preset.contentHash) {
            favoriteButton = (
                <FavoriteButton
                  contentHash={track.preset.contentHash}
                  type={PRESET_RATED}
                />);
        } else if (track && track.sample) {
            favoriteButton = (
                <FavoriteButton
                  contentHash={track.sample.getId()}
                  type={SOUND_RATED}
                />);
        }

        let groups = !this.props.selectedSteps ? [] :
            Array.from(new Set(this.props.selectedSteps.map(s => s && s.group).filter(s => s)));
        return (
            <div
              onMouseLeave={() => this.onMouseUp()}
              onMouseUp={() => this.onMouseUp()}
              className="track-quick-view">
              <div className="name-component">
                {this.getThumbnail()}
                <div className="name-label">{this.track.presetName || this.track.getName()}</div>
                <PulseLoader
                    sizeUnit={"px"}
                    size={10}
                    color={'#123abc'}
                    loading={this.state.loading}
                    />
                {favoriteButton}
                <Documented className="sample-arrows" element={BROWSE_SOUNDS}>
                  <i onClick={() => this.previousSample()} className="left"></i>
                  <i onClick={() => this.nextSample()} className="right"></i>
                </Documented>
              </div>
              <div className="parameter-options">
                <ParameterOption
                  onClick={() => this.chooseParameter(trackData.durationParameter)}
                  selected={selectedParameter === trackData.durationParameter}
                  isCirklonSelected={trackData.durationParameter.name === this.props.cirklonParameterSelected}
                  name="Dur."/>
                  <ParameterOption
                    onClick={() => this.chooseParameter(trackData.transposeParameter)}
                    isCirklonSelected={trackData.transposeParameter.name === this.props.cirklonParameterSelected}
                    selected={selectedParameter === trackData.transposeParameter}
                    name="Trsp."/>
                <ParameterOption
                  onClick={() => this.chooseParameter(trackData.attackParameter)}
                  isCirklonSelected={trackData.attackParameter.name === this.props.cirklonParameterSelected}
                  selected={selectedParameter === trackData.attackParameter}
                  name="Atk."/>
                <ParameterOption
                  onClick={() => this.chooseParameter(trackData.releaseParameter)}
                  isCirklonSelected={trackData.releaseParameter.name === this.props.cirklonParameterSelected}
                  selected={selectedParameter === trackData.releaseParameter}
                  name="Rel."/>
                <ParameterOption
                  onClick={() => this.chooseParameter(trackData.velocityParameter)}
                  isCirklonSelected={trackData.velocityParameter.name === this.props.cirklonParameterSelected}
                  selected={selectedParameter === trackData.velocityParameter}
                  name="Vel."/>
                <ParameterValue
                  value={this.getValue()}
                />
              </div>
              <div
                className="track-slider-container"
                onMouseLeave={() => this.onMouseUp()}
                >
                <ReactBootstrapSlider
                  value={parseFloat(this.getValue())}
                  change={(e) => this.onUpdateParameter(e.target.value)}
                  step={selectedParameter.name === "Transpose" ? 1 : 0.01}
                  max={max}
                  min={min}
                  orientation="horizontal"
                  reversed={false}
                  />
                <StepsButton track={track} selectedSteps={this.props.selectedSteps}/>
              </div>
              {groups.map(group => <StepGroupEditor
                                     track={track}
                                     key={group.id} sequencerEngine={this.props.sequencerEngine} group={group}/>)}
            </div>
        );
    }
}

function ParameterValue(props) {
    return (
        <div
          className="parameter-value">{props.value}
        </div>
    );
}

function ParameterOption(props) {
    let className = 'parameter-option';
    if (props.selected) {
        className += ' selected';
    }

    if (props.isCirklonSelected) {
        className += ' cirklon-selected';
    }

 
    return (
        <div
          onClick={props.onClick}
          className={className}>{props.name}</div>
    );
}

function getMin(parameter, trackData) {
    if (parameter === trackData.durationParameter) {
        return 0.01;
    } else {
        return parameter.min;
    }
}

function getMax(parameter, trackData) {
    if (parameter === trackData.durationParameter ) {
        return 4;
    } else if (parameter === trackData.attackParameter) {
        return 100;
    } else if (parameter === trackData.releaseParameter) {
        return 400;
    }
    return parameter.max;
}

const mapDispatchToProps = dispatch => {
    return {
        setParametersToRecord: params => dispatch(setParametersToRecord(params)),
    }
};

const mapStateToProps = (state, props) => {
    let id = props.sequencerEngine.engineId;
    let currentSubSequence = state.sequencer.currentSubSequence[id];
    let currentPattern = state.sequencer.currentPattern[currentSubSequence] || 0;

    let track = props.sequencerEngine.tracks && props.sequencerEngine.tracks[state.mix.selectedTrack];
    return {
        id: track === undefined ? 0 :
            track.presetName ? track.presetName : 
            track.sample !== undefined && track.sample.getId() !== undefined ?
            track.sample.getId() : track.getName(),
        numTracks: props.sequencerEngine.tracks && props.sequencerEngine.tracks.length,
        currentPattern: currentPattern,
        currentSubSequence: currentSubSequence,
        selectedTrack: state.mix.selectedTrack,
        selectedSteps: state.keyboard.selectedPianoRollSteps,
        cirklonParameterSelected: state.steps.cirklonParameterSelected,
        stepGroups: state.steps.stepGroups
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(TrackQuickView);

